import { render, staticRenderFns } from "./ListProgram.vue?vue&type=template&id=e45479d0&scoped=true"
import script from "./ListProgram.vue?vue&type=script&lang=js"
export * from "./ListProgram.vue?vue&type=script&lang=js"
import style0 from "./ListProgram.vue?vue&type=style&index=0&id=e45479d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45479d0",
  null
  
)

export default component.exports